// Entry point for React app
// Import process polyfill first to ensure process.env is defined
import './processPolyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';

// Register document-generation bearer authentication before the app renders.
import './api/documentGenerationAuth';

// Initialize i18n before app renders
import './i18n/i18n';

// Import Bootstrap CSS FIRST (critical for consistent styling)
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Import custom Bootstrap overrides IMMEDIATELY after Bootstrap
import '../src/custom-bootstrap.css';

// Then import app styles
import './styles/index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
